import React from 'react';

import { Typography, Divider, Progress } from 'antd';
import { useWizard } from 'components/shared/Wizard';

const { Title } = Typography;

const SideBarProgress = () => {
  const { activeStep, stepCount } = useWizard();
  const progressPercentage = (activeStep / (stepCount - 1)) * 100;
  return (
    <>
      <Title level={4}>Your application</Title>
      <Progress percent={progressPercentage} format={(percent) => `${Math.trunc(percent)}%`} />
      <Divider />
    </>
  );
};

export default SideBarProgress;
